module.exports = __webpack_public_path__ + "static/sidebar1-e4f0392b4204188a7979aa2b1bcb8d0b.png";